export default "__VITE_ASSET__DSfOU1t$__"